export default {
    bindings: {
        getSuggestions: '&',
        event: '=',
        parent: '<'
    },
    controller: 'upgradeEventController',
    template: require('../views/upgrade.option.html')
};



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/shared/checkout/components/upgrade.option.component.js